<template lang="pug">
section
  div
    | The Home Office also requires the organisation
    | to nominate members of staff
    | to take on roles in respect
    | of the sponsor licence.
    | There are 3 roles to be appointed
    | or on the application form:
    | Authorising officer, Key contact, Level 1 user.
    | All the roles can be filled by
    |
    b ONE
    |
    | person or
    |
    b different
    |
    | people.

  br

  div
    | Level 2 users can only be appointed
    | by a Level 1 user,
    | so you can only add a Level 2 user
    | after your licence has been granted.

  br

  div
    | The Home Office will make its own checks
    | on nominees during
    | the sponsor licence application process,
    | and your business can be refused a licence
    | due to the character
    | and past behaviour of the key personnel.

  br

  div
    | Key personnel must:

  br

  ul
    li
      | be based in the UK for the period
      | they fill the role you have appointed them to
    li
      | be a paid member of your staff
      | or engaged by you as an ‘office holder’,
      | unless certain exceptions apply for each role;
    li
      | not be subject
      | to unspent criminal convictions
      | or Bankruptcy or failed
      | to pay VAT or other excise duty;
    li
      | not have been fined
      | by the Home Office in the last 12 months;
    li
      | not have been a key personnel
      | at any sponsor organisation
      | where an application for a licence
      | was refused within the last 6 months
      | or where a licence has been revoked
      | within the last 12 months;
    li
      | not have acted in a manner
      | that is conducive to the public good.
</template>

<script>
export default {
  name: "key_personnel_general",
};
</script>